import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "overlay"]

  toggleMobile() {
    const isOpen = this.panelTarget.classList.contains("sidebar-mobile-open")

    if (!isOpen) {
      this.overlayTarget.classList.add("active")
      setTimeout(() => {
        this.panelTarget.classList.add("sidebar-mobile-open")
      }, 50)
    } else {
      this.panelTarget.classList.remove("sidebar-mobile-open")
      this.overlayTarget.classList.remove("active")
    }
  }
}
